var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2538_15515",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20.0001C15.5228 20.0001 20 15.5229 20 10.0001C20 4.47724 15.5228 9.15527e-05 10 9.15527e-05C4.47715 9.15527e-05 0 4.47724 0 10.0001C0 15.5229 4.47715 20.0001 10 20.0001ZM15.4954 6.63112C15.7058 6.35752 15.6547 5.96512 15.3811 5.75466C15.1075 5.5442 14.7151 5.59538 14.5046 5.86898L8.68861 13.4298L5.44194 10.1831C5.19786 9.93903 4.80214 9.93903 4.55806 10.1831C4.31398 10.4272 4.31398 10.8229 4.55806 11.067L8.30806 14.817C8.43523 14.9442 8.61103 15.0104 8.7905 14.9987C8.96998 14.9871 9.13573 14.8987 9.24539 14.7561L15.4954 6.63112Z",
    fill: "#000001"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2538_15515)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#09A639"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkFilled);
export default __webpack_public_path__ + "static/media/checkmark-filled.b7029a6a282077671ef720d6a88a86c3.svg";
export { ForwardRef as ReactComponent };